import { v1 as uuid } from 'uuid';
import { IProductCatalogItem, ISalesLineForAssuranceDto } from 'gen/ApiClient';
import { IHandoverLine } from '../IHandoverLine';

const toDescription = (t: IProductCatalogItem, line: IHandoverLine | ISalesLineForAssuranceDto): string => {
	if (line.serialNumber) {
		return `${t.name} sn: ${line.serialNumber}`;
	} else {
		return t.name ?? '';
	}
};

export const assuranceToLine = (t: IProductCatalogItem, line: IHandoverLine | ISalesLineForAssuranceDto): IHandoverLine => {
	return {
		isSelected: true,
		id: uuid(),
		description: toDescription(t, line),
		inventoryItemId: undefined,
		productCatalogItemId: t.id,
		quantity: 1,
		unitListPrice: t.salesListPrice,
		unitPrice: t.salesListPrice,
		vatPercentage: t.vatPercentage,
		productCatalogItem: t,
		assuredLineId: line.id,
		assuredProductCatalogItemId: line.productCatalogItemId,
		assuredInventoryItemId: line.inventoryItemId,
		canChangeQuantity: line.inventoryItemId === undefined,
		inventoryItem: undefined,
		isIncludeOnHandoverCertificate: true,
		isRefundable: false,
		manufacturer: '',
		model: '',
		rizivHearingAidDefinitionV2IdentificationCode: undefined,
		serialNumber: '',
		advanceInvoiceId: undefined,
		stockAtLocations: undefined,
		isCredit: false,
	};
};
